export class Constants {
    public static DEFAULT_PAGE_SIZE_SUBGRID = 10;
    public static DEFAULT_PAGE_SIZE_GRID = 50;
    public static RIBBON_BUTTONS_COLUMN_NAME = '_talxis_gridRibbonButtons';
}